import { JL } from "jsnlog";

if (window) {
  window.onerror = function (errorMsg, url, line, column, errorObj) {
    doLog(errorMsg, url, line, column, errorObj);

    return false;
  };

  window.onunhandledrejection = function (event) {
    const reason = typeof event.reason === "string" ? event.reason : (event.reason || {}).message;
    doLog(reason || "unhandled rejection", null, null, null, event.reason);

    return false;
  };
}

function doLog(errorMsg, url, line, column, errorObj) {
  // Error in library that we can't avoid, but don't want to log...
  // Input.js?6340:78 Uncaught TypeError: Cannot read property 'style' of undefined
  // at Input._this.handleAutoresize (VM36082 Input.js:78)
  if (
    errorMsg.includes("TypeError") &&
    errorMsg.includes("style") &&
    errorMsg.includes("undefined")
  ) {
    return;
  }

  JL("onerrorLogger").fatalException(
    {
      msg: errorMsg,
      url,
      line,
      column,
    },
    errorObj
  );
}

// eslint-disable-next-line
function __jsnlog_configure(JL) {
  const sendTimeout = process.env.NODE_ENV === "production" ? undefined : 60 * 2 * 1000;
  const appender = JL.createAjaxAppender("NETCore JSNLog appender");
  appender.setOptions({
    url: process.env.API_URL_ROOT.replace("/graphql", "/jsnlog.logger"),
    sendTimeout,
    beforeSend: (xhr) => {
      const token = localStorage.getItem("atlas:token");
      if (token) {
        xhr.setRequestHeader("Authorization", "Bearer " + token);
      }

      xhr.setRequestHeader("Accept-Language", document.querySelector("html").getAttribute("lang"));
      xhr.setRequestHeader(
        "X-CLIENT-VERSION",
        document.querySelector("#root").getAttribute("data-version")
      );
      xhr.setRequestHeader("X-SPA-URL", document.location.href);
    },
  });

  JL().setOptions({
    appenders: [appender],
  });
}
try {
  __jsnlog_configure(JL);
} catch (e) {
  // Nothing to do here.
}

window.JL = JL;
